import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class OrderDraft extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/order/draft`)
  }

  detail(orderDraftId, showProgress) {
    return this._request({
      action: `${orderDraftId}/detail`,
      method: 'GET',
      showProgress
    })
  }
}
